<template>
<div>
<transition name="slide">
	<div v-show="show" class="summary-wrapper">
		<a class="bill-filter-cancel" @click="cancle">取消</a>
		<nav class="edi-nav">{{title}}</nav>
		<div class="summary-filter-shell">
			<ul class="summary-filter-ul summary-company-select-ul">
				<li @click="selectDateType('0')"><label>订货日期
					<input type="radio" name="selectDateType" v-if="selectJudge('0')" checked>
					<input type="radio" name="selectDateType" v-else>
				</label></li>
				<li @click="selectDateType('1')"><label>到货日期
					<input type="radio" name="selectDateType" v-if="selectJudge('1')" checked>
					<input type="radio" name="selectDateType" v-else>
				</label></li>
				<li @click="selectDateType('2')" v-if="dateShow"><label>收货日期
					<input type="radio" name="selectDateType" v-if="selectJudge('2')" checked>
					<input type="radio" name="selectDateType" v-else>
				</label></li>
				<li @click="selectDateType('3')" v-if="dateShow"><label>入库日期
					<input type="radio" name="selectDateType" v-if="selectJudge('3')" checked>
					<input type="radio" name="selectDateType" v-else>
				</label></li>
			</ul>
		</div>
	</div>
</transition>
</div>
</template>
<script>
import NavBar from '../components/NavBar'
export default {
	props: {
		dateTypeFlag: String,
		title: String
	},
	data () {
		return {
			show: false,
			dateShow: false
		}
	},
	components: {
		'navbar': NavBar
	},
	created () {
		// window.console.log(this.dateTypeFlag)
	},
	methods: {
		cancle () {
			this.show = !this.show
		},
		selectJudge (val) {
			if (this.dateTypeFlag === val) {
				return true
			} else {
				return false
			}
		},
		open (msg) {
			if (msg) {
				this.dateShow = true
			} else {
				this.dateShow = false
			}
			this.show = !this.show
		},
		selectDateType (val) {
			this.show = false
			this.$emit('selectDateType', val)
		}
	}
}
</script>



// WEBPACK FOOTER //
// DateTypeSelect.vue?02b36142